<template>
  <div class="page-container">
    <sub-header>
      <template slot="title">{{$route.meta.title}}
      </template>
      <template slot="btn">
        <el-dropdown @command="handleAddPlanCommand"
                     v-if="M2Integration"
                     v-has="'Add Plan'">
          <el-button type="primary"
                     size="medium">
            {{$t('home.AddPlan')}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">{{$t('project.CreateWithPdfs')}}</el-dropdown-item>
            <el-dropdown-item command="2">{{$t('project.CreateWithCloud')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-else
                   size="medium"
                   @click="openAddPlanFromPdfDialog()"
                   v-has="'Add Plan'"
                   type="primary"
                   icon="el-icon-plus"> {{$t('home.AddPlan')}} </el-button>
      </template>
      <template slot="search">
        <el-row :gutter="20">
          <el-col :lg="4"
                  :md="6"
                  :sm="6"
                  :xs="6">
            <el-input size="mini"
                      :placeholder="$t('diagrams.SearchPlanName')"
                      v-model="condition.Name"
                      @change="search()"
                      clearable></el-input>
          </el-col>
          <el-col :lg="4"
                  :md="6"
                  :sm="6"
                  :xs="6">
            <el-select v-model="condition.TagId"
                       clearable
                       filterable
                       default-first-option
                       @change="search()"
                       size="mini"
                       :placeholder="$t('diagrams.SearchTag')">
              <el-option v-for="item in tags"
                         :key="item.TagId"
                         :label="item.Name"
                         :value="item.TagId">
                <span class="tag-color"
                      :style="{background: item.Color}"></span>
                <span>{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-col>
          <SortControl @sortList="sortList"
                       :orderBy="sortValue">
            <template slot="sort">
              <el-select size="mini"
                         @change="sort"
                         placeholder="Orderby"
                         v-model="sortBy">
                <el-option v-for="item in sortType"
                           :key="item.name"
                           :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </template>
          </SortControl>
        </el-row>
      </template>
      <template slot="tab-btn">
        <el-tooltip class="item"
                    effect="dark"
                    :content="toggleGridListViewContent"
                    placement="bottom-start">
          <el-link :icon="toggleIcon"
                   :underline="false"
                   style="font-size:20px;"
                   @click="changePlanTabType"></el-link>
        </el-tooltip>
      </template>
    </sub-header>
    <div class="main">
      <div v-if="planTabType==='Grid'"
           class="plan-list"
           v-loading="loading">
        <myScroll style="width:100%;height:100%">
          <div class="list">
            <div class="cube-box"
                 v-for="i of plans"
                 :key="i.PlanId">
              <div class="cube">
                <div class="tool-box"
                     @click="pushToModel(i)">
                  <el-tooltip class="item"
                              effect="dark"
                              content="Cloud has a newer version"
                              placement="top">
                    <span class=" revisionUpdateIcon">
                      <i class="el-icon-warning"
                         v-if="i.LastRevision > i.Revision"></i>
                    </span>
                  </el-tooltip>
                  <img :src="i.url"
                       v-if="i.url"
                       class="image">
                  <i class="iconfont iconpicture no-pic"
                     v-if="!i.url"></i>
                  <el-tooltip class="item"
                              effect="dark"
                              :open-delay="400"
                              :content="i.Name"
                              placement="bottom-start">
                    <h3 class="name">
                      {{i.Name}}
                    </h3>
                  </el-tooltip>
                  <el-popover class="item"
                              trigger="hover"
                              placement="top"
                              :open-delay="400"
                              v-if="i.SelectTags && i.SelectTags.length>0">
                    <div class="tag-group">
                      <el-tag v-for="tag in i.SelectTags"
                              :key="tag.TagId"
                              :style="{'border':'none','background-color': tag.Color}"
                              effect="dark">
                        {{ tag.Name }}
                      </el-tag>
                    </div>
                    <div class="tags"
                         slot="reference">
                      <svg-icon iconClass="tag"></svg-icon> <span class="count">{{i.SelectTags.length}}</span>
                    </div>
                  </el-popover>
                  <h3 class="task">
                    <svg-icon iconClass="planTasks"></svg-icon><i class="iconfont icondatabase"></i> {{$t('diagrams.Today')}} {{i.TotayTaskCount}} / {{$t('diagrams.Open')}} {{i.OpenTaskCount}}
                  </h3>
                </div>
                <div class="diagram-btn"
                     v-has="'Delete Plan'">
                  <el-dropdown @command="handleCommand"
                               trigger="click">
                    <el-button type="primary">
                      <i class="el-icon-more"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{action:1, item:i}">
                        <el-link :underline="false">Edit</el-link>
                      </el-dropdown-item>
                      <el-dropdown-item :command="{action:2, item:i}">
                        <el-link :underline="false"
                                 type="danger">Delete</el-link>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <div v-if="plans.length === 0 && !loading"
                 class=" no-data">
              {{$t('diagrams.NoData')}}
            </div>
          </div>
        </myScroll>

      </div>
      <div v-else
           class="table-box">
        <myScroll style="width:100%;height:100%">
          <el-table :data="plans"
                    ref="planTable"
                    size="small"
                    v-loading="loading"
                    :highlight-current-row="false"
                    style="position:absolute"
                    :default-sort="{prop: sortBy, order: sortStr}"
                    :sort-orders="sortOrders"
                    @sort-change="sortChange">
            <el-table-column :label="$t('diagrams.Name')"
                             prop="Name"
                             sortable="custom"
                             :sort-orders="sortOrders">
              <template slot-scope="scope">
                <div class="row-link"
                     @click="pushToModel(scope.row)">
                  <span class="row-name">
                    <img :src="scope.row.url"
                         v-if="scope.row.url">
                    <span class="plan-name">{{scope.row.Name}}</span>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('diagrams.Tasks')"
                             width="165">
              <template slot-scope="scope">
                <div class="items">
                  <span class="task">
                    <svg-icon iconClass="planTasks"></svg-icon><i class="iconfont icondatabase"></i> {{$t('diagrams.Today')}} {{scope.row.TotayTaskCount}} / {{$t('diagrams.Open')}} {{scope.row.OpenTaskCount}}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('diagrams.Tags')"
                             prop="SelectTags">
              <template slot-scope="scope">
                <div class="tag-group"
                     v-if="scope.row.SelectTags && scope.row.SelectTags.length>0&&scope.row.SelectTags.length<3">
                  <el-tag v-for="tag in scope.row.SelectTags"
                          :key="tag.TagId"
                          :style="{'border':'none','background-color': tag.Color}"
                          effect="dark">
                    {{ tag.Name }}
                  </el-tag>
                </div>
                <el-popover class="item"
                            trigger="hover"
                            placement="top"
                            :open-delay="400"
                            v-if="scope.row.SelectTags && scope.row.SelectTags.length>2">
                  <div class="tag-group">
                    <el-tag v-for="tag in scope.row.SelectTags"
                            :key="tag.TagId"
                            :style="{'border':'none','background-color': tag.Color}"
                            effect="dark">
                      {{ tag.Name }}
                    </el-tag>
                  </div>
                  <div class="tags"
                       slot="reference">
                    <svg-icon iconClass="tag"></svg-icon> <span class="count">{{scope.row.SelectTags.length}}</span>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column :label="$t('diagrams.CreatedOn')"
                             prop="CreatedOn"
                             width="200"
                             sortable="custom"
                             :sort-orders="sortOrders">
              <template slot-scope="scope">
                {{scope.row.CreatedOn}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('report.Actions')"
                             width="120">
              <template slot-scope="scope">
                <el-tooltip class="item"
                            effect="dark"
                            :content="$t('diagrams.EditPlan')"
                            placement="bottom">
                  <el-button circle
                             size="mini"
                             icon="el-icon-edit"
                             v-has="'Delete Plan'"
                             @click="handleCommand({action:1, item:scope.row})"
                             type="success"></el-button>
                </el-tooltip>
                <el-tooltip class="item"
                            effect="dark"
                            :content="$t('diagrams.Delete')"
                            placement="bottom"
                            v-has="'Delete Plan'">
                  <el-button circle
                             size="mini"
                             icon="el-icon-delete"
                             @click="handleCommand({action:2, item:scope.row})"
                             type="danger"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </myScroll>
      </div>
      <page ref="pagination"
            :total="total"
            :PageSize="condition.PageSize"
            :PageIndex="condition.PageIndex"
            @handleCurrentChange="handleCurrentChange"></page>
    </div>
    <Diagrams-Dialog :showDialog="diagramsDialog.showDialog"
                     @closeDialog="closeDiagramsDialog"></Diagrams-Dialog>
    <addPlanFromPdfDialog :showDialog="addPlanFromPdfDialog.showDialog"
                          @closeDialog="closeAddPlanFromPdfDialog">
    </addPlanFromPdfDialog>
    <renameDialog :showDialog="renameDialog.showDialog"
                  :planId="renameDialog.planId"
                  :planName="renameDialog.planName"
                  :tagIds="renameDialog.tagIds"
                  @createNewTags="handleCreateNewTags"
                  @closeDialog="closeRenameDialog">
    </renameDialog>

    <!-- <addPlanFromPdfKitDialog :showDialog="addPlanFromPdfDialog.showDialog"
                             @closeDialog="closeAddPlanFromPdfDialog"></addPlanFromPdfKitDialog>-->
  </div>
</template>

<script>
import { deletePlans, getPlansList, getTags, getM2ProjectRevisions, getM2ProjectRevision, updatePlanRevsions } from '@/api/config'
import { mapState } from 'vuex'
import DiagramsDialog from '@components/diagrams/diagramsDialog.vue'
import addPlanFromPdfDialog from '@/components/diagrams/addPdfPlanDialog.vue'
import renameDialog from '@components/diagrams/renameDialog.vue'
// import addPlanFromPdfKitDialog from '@/components/diagrams/addPlanFromPdfKitDialog.vue'
import SortControl from '@components/common/sortBtnList'
import axios from 'axios'

export default {
  data () {
    return {
      loading: false,
      condition: {
        PageIndex: 1,
        PageSize: 20,
        Name: null,
        TagId: null,
        AllowLoadTaskCount: true,
        AllowLoadTags: true,
        Today: null,
        OrderBy: 'CreatedOn desc'
      },
      tagCondition: {
        PageIndex: 1,
        PageSize: 9999,
        OrderBy: 'Name asc'
      },
      total: 0,
      plans: [],
      tags: [],
      showTextBool: false,
      number: -1,
      renameDialog: {
        showDialog: false,
        planId: null,
        planName: null,
        tags: null
      },
      diagramsDialog: {
        showDialog: false,
        step: 1
      },
      addPlanFromPdfDialog: {
        showDialog: false
      },
      sortType: [
        {
          name: this.$t('task.Name'),
          value: 'Name'
        }, {
          name: this.$t('task.CreatedOn'),
          value: 'CreatedOn'
        }, {
          name: this.$t('task.UpdatedOn'),
          value: 'LastUpdatedOn'
        }],
      sortValue: 'desc',
      sortBy: 'CreatedOn',
      planImageList: [],
      planTabType: this.$store.state.planTabType,
      sortStr: 'descending',
      sortOrders: ['ascending', 'descending']
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'userInfo', 'mockUserInfo', 'M2Integration', 'planCondition', 'planConditionOrderby']),
    reload () {
      return this.$route.query.r
    },
    toggleGridListViewContent () {
      return this.planTabType === 'Grid' ? this.$t('diagrams.ListView') : this.$t('diagrams.GridView')
    },
    toggleIcon () {
      return this.planTabType === 'Grid' ? 'el-icon-s-unfold' : 'el-icon-s-grid'
    }
  },
  created () {
    if ((this.reload === '1' || this.reload === 1) && this.planCondition) {
      this.condition = Object.assign({}, this.planCondition)
      this.condition.AllowLoadTags = true
    } else {
      this.$store.commit('setPlanCondition', null)
    }
    this.setPlanConditionOrderBy()
    this.condition.Today = this.$config.UTCTime(null, true)
    this.planImageList = []
    this.getTags()
    this.getPlanList()
    if (this.$route.query.t && (this.$route.query.t === 'Grid' || this.$route.query.t === 'List')) {
      this.planTabType = this.$route.query.t
    }
  },
  mounted () {
  },
  watch: {

  },
  methods: {
    handleCreateNewTags () {
      this.Tags = this.getTags()
    },
    handleCommand (command) {
      if (command.action === 1) {
        this.renameDialog.showDialog = true
        this.renameDialog.planId = command.item.PlanId
        this.renameDialog.planName = command.item.Name
        this.renameDialog.tagIds = command.item.Tags.map(q => q.TagId)
      } else if (command.action === 2) {
        this.deletePlan(command.item)
      }
    },
    search () {
      this.condition.PageIndex = 1
      this.getPlanList()
    },
    closeDiagramsDialog (needRefresh) {
      this.diagramsDialog.showDialog = false
      if (needRefresh === true) {
        this.getPlanList()
      }
    },
    openDiagramsDialog () {
      this.diagramsDialog.showDialog = true
    },
    handleCurrentChange (val) {
      this.condition.PageIndex = val
      this.getPlanList()
    },
    getTags () {
      getTags(this.tagCondition).then(async res => {
        if (res.Data && res.Data.length > 0) {
          this.tags = res.Data
          for (let tag of this.tags) {
            tag.Color = this.$config.unit2RGBA(tag.Color)
          }
        }
      })
    },
    getPlanList () {
      let that = this
      this.plans = []
      this.loading = true
      this.condition.JobsiteId = this.jobsiteID
      this.condition.OrderBy = this.getPlanConditionOrderBy()
      if (!this.condition.PageIndex) {
        this.condition.PageIndex = 1
        this.condition.PageSize = 20
      }
      getPlansList(this.condition).then(async res => {
        console.log(this.condition)
        that.total = res.TotalCount
        if (res.Data && res.Data.length > 0) {
          let ids = res.Data.map(q => q.LinkProjectId)
          let uniqueArray = Array.from(new Set(ids))
          await getM2ProjectRevisions(uniqueArray).then(r => {
            for (let plan of res.Data) {
              let projectRevsion = r.find(q => q.ProjectId === plan.LinkProjectId)
              if (projectRevsion != null) {
                plan.LastRevision = projectRevsion.Revision
              } else {
                plan.LastRevision = plan.Revision
              }
            }
          })
        }
        res.Data.forEach(ele => {
          ele.url = require('../../../assets/image/blank.png')
          ele.CreatedOn = this.$config.LocalTime(new Date(ele.CreatedOn))
          ele.SelectTags = that.tags.filter(q => ele.Tags.find(s => s.TagId === q.TagId))
          ele.tagsText = ele.SelectTags ? ele.SelectTags.map(q => q.Name).join(', ') : ''
          that.plans.push(ele)
        })
        that.loading = false
        for (let ele of that.plans) {
          if (!that.loading) {
            if (!ele.IsLoadImage) {
              ele.url = await that.getPlanImageUrl(ele)
            } else {
              ele.url = this.$config.baseURL + '/api/Plans/' + ele.PlanId + '/Image/?' + Math.random()
            }
          } else {
            break
          }
        }
      })
    },
    sortList () {
      if (this.sortValue === 'asc') {
        this.sortValue = 'desc'
      } else {
        this.sortValue = 'asc'
      }
      this.sort()
    },
    sort () {
      this.condition.OrderBy = this.getPlanConditionOrderBy()
      this.savePlanConditionOrderBy()
      this.getPlanList()
    },
    getPlanConditionOrderBySplit () {
      return ' '
    },
    getPlanConditionOrderBy () {
      return this.sortBy + this.getPlanConditionOrderBySplit() + this.sortValue
    },
    setPlanConditionOrderBy () {
      let arr = this.planConditionOrderby.split(this.getPlanConditionOrderBySplit())
      if (arr && arr.length === 2) {
        this.sortBy = arr[0]
        this.sortValue = arr[1]
      }
    },
    savePlanConditionOrderBy () {
      this.$store.commit('setPlanConditionOrderby', this.condition.OrderBy)
    },
    goToPlanDetail (plan) {
      this.$store.commit('setPlan', plan)
      this.$store.commit('setPlanCondition', Object.assign({}, this.condition))
      if (plan.PlanType === 2) {
        this.$router.push({
          name: 'taskList2',
          params: {
            projectId: this.jobsiteID,
            planId: plan.PlanId
          }
        })
      } else {
        this.$router.push({
          name: 'taskList',
          params: {
            projectId: this.jobsiteID,
            planId: plan.PlanId
          }
        })
      }
    },
    async pushToModel (plan) {
      if (plan.PlanType === 0) {
        if ((this.userInfo.RoleType === 1 || this.userInfo.RoleType === 2) && !(this.mockUserInfo && this.mockUserInfo.UserId)) {
          let revision = await getM2ProjectRevision(plan.LinkProjectId)
          if (revision > plan.Revision) {
            this.$confirm('Cloud has a newer version, are you sure you want to update the plan?', this.$t('taskDialog.TIPS'), {
              confirmButtonText: this.$t('taskDialog.Yes'),
              cancelButtonText: this.$t('taskDialog.No'),
              distinguishCancelAndClose: true,
              type: 'warning'
            }).then(async () => {
              let sameProductCondition = {
                JobsiteId: this.jobsiteID,
                PageSize: 9999,
                LinkProjectId: plan.LinkProjectId
              }
              let pageModel = await getPlansList(sameProductCondition)
              let updatePlans = []
              for (let plan of pageModel.Data) {
                updatePlans.push({
                  PlanId: plan.PlanId,
                  Name: plan.Name,
                  Revision: revision
                })
              }
              await updatePlanRevsions(updatePlans)
              this.goToPlanDetail(plan)
            }).catch((action) => {
              if (action === 'cancel') {
                this.goToPlanDetail(plan)
              }
            })
            return
          }
        }
      }
      this.goToPlanDetail(plan)
    },
    deletePlan (item) {
      if (item.AllTaskCount > 0) {
        this.$notify({
          showClose: false,
          title: this.$t('diagrams.Warning'),
          type: 'warning',
          message: this.$t('diagrams.cannotBeDeleted')
        })
        return
      }
      this.$confirm(this.$t('diagrams.wantToDelete', [item.Name]), this.$t('diagrams.TIPS'), {
        confirmButtonText: this.$t('diagrams.Yes'),
        cancelButtonText: this.$t('diagrams.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        let params = []
        params.push(item.PlanId)
        deletePlans(params).then(res => {
          this.$refs.pagination.handleDelete()
        })
      }).catch(() => {
      })
    },
    handleAddPlanCommand (command) {
      if (command === '1') {
        this.openAddPlanFromPdfDialog()
      } else if (command === '2') {
        this.openDiagramsDialog()
      }
    },
    openAddPlanFromPdfDialog () {
      this.addPlanFromPdfDialog.showDialog = true
    },
    closeAddPlanFromPdfDialog (needRefresh) {
      this.addPlanFromPdfDialog.showDialog = false
      if (needRefresh === true) {
        this.getPlanList()
      }
    },
    closeRenameDialog (val) {
      this.renameDialog.showDialog = false
      if (val.PlanId) {
        // this.getPlanList()
        const index = this.plans.findIndex(item => item.PlanId === val.PlanId)
        if (index !== -1) {
          var plan = this.plans[index]
          plan.Name = val.Name
          plan.Tags = this.tags.filter(q => val.TagIds.includes(q.TagId))
          plan.SelectTags = this.tags.filter(q => val.TagIds.indexOf(q.TagId) > -1)
          plan.tagsText = plan.SelectTags ? plan.SelectTags.map(q => q.Name).join(', ') : ''
          this.$set(this.plans, index, plan)
        }
      }
    },
    getPlanImageUrl (plan) {
      let that = this
      let planImage = that.planImageList.find(p => p.PlanId === plan.PlanId)
      if (planImage) {
        return planImage.url
      }
      return axios({
        method: 'get',
        url: this.$config.baseURL + '/api/Plans/' + plan.PlanId + '/Image/?' + Math.random(),
        responseType: 'blob',
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
          'Authorization': 'Bearer ' + this.$store.state.userInfo.Token
        }
      }).then((res) => {
        let blob = new Blob([res])
        let objectUrl = URL.createObjectURL(blob)
        if (!that.planImageList.find(p => p.PlanId === plan.PlanId)) {
          that.planImageList.push({ PlanId: plan.PlanId, url: objectUrl })
        }
        return objectUrl
      })
    },
    changePlanTabType () {
      this.planTabType = this.planTabType === 'Grid' ? 'List' : 'Grid'
      this.$store.commit('planTabType', this.planTabType)
    },
    sortChange (column) {
      this.sortBy = column.prop
      this.sortStr = column.order
    }
  },
  components: {
    renameDialog,
    DiagramsDialog,
    addPlanFromPdfDialog,
    SortControl
    // addPlanFromPdfKitDialog
  }
}
</script>

<style scoped lang="scss">
.tag-color {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: text-bottom;
  margin-right: 12px;
}
.plan-list {
  width: 100%;
  flex: 1;
  height: 0;
  position: relative;
  .list {
    .cube-box {
      box-sizing: border-box;
      width: 20%;
      padding: 0 8px;
      float: left;
      overflow: hidden;
      margin-bottom: 16px;
      .cube {
        position: relative;
        border-radius: 5px;
        overflow: hidden;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        .tool-box {
          width: 100%;
          height: 100%;
          overflow: hidden;
          .revisionUpdateIcon {
            position: absolute;
            right: 8px;
            top: 8px;
            font-size: 22px;
            color: #ff9600;
          }
          img {
            height: 170px;
            /* width: 170px; */
            display: block;
            margin: 12px auto;
          }
          .name {
            margin: 0;
            box-sizing: border-box;
            width: 80%;
            height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: normal;
            font-size: 14px;
            line-height: 20px;
            text-align: left;
            float: left;
            padding-left: 8px;
          }
          .tags {
            width: 20%;
            height: 24px;
            line-height: 20px;
            display: inline-block;
            font-size: 14px;
            text-align: center;
            vertical-align: bottom;
            padding-right: 8px;
            box-sizing: border-box;
            .count {
              vertical-align: middle;
              display: inline-block;
              margin-left: -2px;
              font-size: 13px;
            }
          }
          .task {
            width: 80%;
            margin: 0;
            height: 20px;
            float: left;
            padding: 8px 0 8px 8px;
            font-size: 14px;
            font-weight: normal;
            color: #909399;
            .svg-icon {
              font-size: 18px;
              color: #4193f6;
            }
          }
        }
        .diagram-btn {
          position: absolute;
          right: 0px;
          bottom: 0;
          height: 38px;
          text-align: center;
          .el-button {
            border: none;
            background: none;
            color: #4193f6;
            font-size: 16px;
          }
          .el-link {
            font-size: 22px;
          }
        }
      }
    }
  }
}
.table-box {
  .row-name {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    img {
      display: inline-block;
      max-height: 40px;
      vertical-align: middle;
    }
    .plan-name {
      display: inline-block;
      vertical-align: middle;
      margin-left: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 80%;
    }
  }
}

.tag-group {
  display: block;
  align-items: center;
  .el-tag {
    margin-right: 10px;
    margin-bottom: 5px;
  }
}
.table-box {
  flex: 1;
  height: 0;
  margin: 0 8px;
  border: 1px solid #dcdfe6;
  .table-icon {
    width: 24px;
  }
  .svg-icon {
    font-size: 20px;
  }
  .row-link {
    cursor: pointer;
    width: 100%;
    height: 100%;
    color: #409eff;
    text-decoration: none;
  }
}
@media (max-width: 1120px) {
  .plan-list {
    .list {
      .cube-box {
        width: 33.3%;
      }
    }
  }
}
/deep/.el-table .caret-wrapper {
  display: none;
}
/deep/.el-table th.is-sortable {
  cursor: auto;
}
</style>
